<template>
  <div>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="Spinner">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCard style="margin-top: 20px" v-else>
      <CCardHeader>
        <div style="margin: auto" class="flexColumn">
          <DatePicker
            v-model="value1"
            type="date"
            range
            placeholder="Select date range"
          ></DatePicker>
          <br />
          <br />
          <h4>Filter with GameTime and GameName</h4>
          <div class="row">
            <div class="col-sm-4">
              <VueCtkDateTimePicker v-model="starttime" style="width: 20" />
            </div>
            <div class="col-sm-4">
              <CSelect
                v-model="GameNames"
                :options="options"
                placeholder="Please select Game Name"
              />
            </div>
            <div class="col-sm-4">
              <CButton
                color="success"
                style="width: 150px"
                @click="filterdata()"
                >search</CButton
              >
            </div>
          </div>
          <div></div>
          <!-- <CButton color="success" style="" v-if="tbl2" @click="refresh()"
            >Go to all data</CButton
          > -->
        </div>
        <JsonCSV
          v-if="tbl1"
          style="
            background-color: #4638c2;
            color: white;
            float: right;
            margin-top: 20px;
          "
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData"
          name="gamepointEntry.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV>
        <JsonCSV
          v-if="tbl2"
          style="
            background-color: #4638c2;
            color: white;
            float: right;
            margin-top: 20px;
          "
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData2"
          name="gamepointEntry.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV>
      </CCardHeader>

      <CCardBody>
        <CDataTable
          v-if="tbl1"
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
          responsive
        >
          <!-- <template #date="{ item }">
            <br />
            <span>{{ item.date }}</span>
          </template> -->
        </CDataTable>
      </CCardBody>
      <CCardBody>
        <CDataTable
          v-if="tbl2"
          :items="tableData2"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
        </CDataTable>
      </CCardBody>
      <!-- <CCardBody  
          v-if="tbl3">
         <CDataTable
        
          :items="tableData3"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
        </CDataTable>
      </CCardBody> -->
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import firebase from "firebase";
const db = firebase.firestore();
import { secondaryDatabase } from "./secondary.js";
import Swal from "sweetalert2";
import moment from "moment";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: {
    JsonCSV,
    DatePicker,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      GameNames: "",
      activeTab: 1,
      value1: [],
      options: [],
      tbl1: true,
      tbl2: false,
      tbl3: false,
      Spinner: true,
      tableData: [],
      userdata: [],
      tableData2: [],
      tableData3: [],
      starttime: "",
      // isFilter:true,
      fields: [
        {
          label: "Date",
          key: "date",
          sortable: true,
        },
        {
          label: "Email",
          key: "email",
          sortable: true,
        },

        {
          label: "GameName",
          key: "gameName",
          sortable: true,
        },

        {
          label: "MatchStartTime",
          key: "matchStartTime",
          sortable: true,
        },
        {
          label: "userwalletAddress",
          key: "userwalletAddress",
          sortable: true,
        },

        // {
        //   label: "Country",
        //   key: "country",
        //   sortable: true,
        // },
      ],
    };
  },
  // computed: {
  //   starttime() {},
  // },
  watch: {
    value1() {
      // let v1 = moment(this.value1[0]).format("DD-MMM-YYYY");
      // let v2 = moment(this.value1[1]).format("DD-MMM-YYYY");
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
      this.tableData2 = [];
      this.tbl1 = false;
      this.tbl2 = true;
      db.collection("esportsGamesEntry")
        .where("date", ">=", v1)
        .where("date", "<=", v2)
        .get()
        .then((snapshot) => {
          this.tableData2 = [];
          snapshot.forEach((doc) => {
            // let emaildata = this.userdata.filter((a) => {
            //   return a.email == doc.data().email;
            // });
            this.Spinner = false;
            let backenddate = moment(doc.data().date.seconds * 1000).format(
              "DD-MMM-YYYY"
            );
            // if (backenddate >= v1 && backenddate <= v2) {
            this.tableData2.push({
              email: doc.data().email,
              gameName: doc.data().gameName,
              matchStartTime: moment(
                doc.data().enchStartTime.seconds * 1000
              ).format("DD-MMM-YYYY, hh:mm a"),

              userGameId: doc.data().userGameID,
              userGameName: doc.data().walletAddress,
              userwalletAddress: doc.data().txnhsh,
              date: moment(doc.data().date.seconds * 1000).format(
                "DD-MMM-YYYY"
              ),
              paymentType: doc.data().userGameName,
              transaction_hash: doc.data().token,
            });
            // }
          });
        });
    },
  },
  methods: {
    filterdata() {
      if (this.GameNames == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Select a Game",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      // this.tableData = [];
      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.starttime));
      // this.tableData = [];
      db.collection("esportsGamesEntry")
        .where("gameName", "==", this.GameNames)

        .orderBy("date", "desc")
        // .limit(100)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            // this.tbl1 = false;
            // this.tbl2 = true;
            this.tableData = [];

            snapshot.forEach((doc) => {
              this.Spinner = false;
              if (doc.data().enchStartTime.seconds == v1.seconds) {
                this.tableData.push({
                  email: doc.data().email,
                  gameName: doc.data().gameName,
                  matchStartTime: moment(
                    doc.data().enchStartTime.seconds * 1000
                  ).format("DD-MMM-YYYY, hh:mm a"),

                  userGameId: doc.data().userGameID,
                  userGameName: doc.data().walletAddress,
                  userwalletAddress: doc.data().txnhsh,
                  date: moment(doc.data().date.seconds * 1000).format(
                    "DD-MMM-YYYY"
                  ),
                  paymentType: doc.data().userGameName,
                  transaction_hash: doc.data().token,
                });
              }
            });
          }
        });
    },
    // isFilter(){
    //   this.isFilter = true
    // },
    refresh() {
      window.location.reload();
      // this.tbl1=true;
      //  this.tbl2=false;
    },
    getuserlist() {
      db.collection("users")

        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.userdata.push({
              name: doc.data().firstName,
              email: doc.data().email,

              country: doc.data().country,
            });
          });
        });
    },
    getmessage() {
      var startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      var endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      db.collection("esportsGamesEntry")
        .where("date", ">=", startOfToday)
        .where("date", "<=", endOfToday)
        .orderBy("date", "desc")
        // .limit(100)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            this.tbl1 = true;
            this.tbl2 = false;
            snapshot.forEach((doc) => {
              this.Spinner = false;

              this.tableData.push({
                email: doc.data().email,
                gameName: doc.data().gameName,
                matchStartTime: moment(
                  doc.data().enchStartTime.seconds * 1000
                ).format("DD-MMM-YYYY, hh:mm a"),

                userGameId: doc.data().userGameID,
                userGameName: doc.data().walletAddress,
                userwalletAddress: doc.data().txnhsh,
                date: moment(doc.data().date.seconds * 1000).format(
                  "DD-MMM-YYYY"
                ),
                paymentType: doc.data().userGameName,
                transaction_hash: doc.data().token,
              });
            });
          } else {
            this.Spinner = false;
            this.tableData = [];
          }
        });
    },

    rowClicked(item, index, column, e) {
      this.documentId = item.id;
    },

    deleteRoute(item) {
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("messagetest")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.getmessage();
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
    GetgameName() {
      db.collection("esports")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            for (let i = 0; i < doc.data()["games"].length; i++) {
              this.options.push(doc.data()["games"][i].name);
            }
          });
        });
    },
  },
  created() {
    // this.getuserlist();
    this.getmessage();
    this.GetgameName();
    // this.sendmsg();
  },
};
</script>
<style>
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
.field-input {
  /* width: 70% !important; */
  margin-left: 20px;
}
</style>
